import React from 'react';

const Project = ({ project }) => {
    return (
        <div className='project'>
            <a rel='noopener noreferrer' target='_blank' href={project.liveURL}><img src={project.imgURL} alt={project.name} /></a>
            <div className='project-title'>
                <h4><a rel='noopener noreferrer' target='_blank' href={project.liveURL}>{project.name}</a></h4>
                <a rel='noopener noreferrer' target='_blank' href={project.githubURL}><i className='fab fa-github'></i></a>
            </div>
        </div>
    )
}

export default Project;